module.exports = __webpack_public_path__ + "img/success8.69948435.gif";